// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';

import desktopFooter from '../../images/left-bottom-background.png';
import desktopHeaderLeft from '../../images/left-top-background.png';

import { Header, Footer } from '../../components';
import { headerLinks, footerLinks } from '../../config/navigationConstants';
import styles from './styles';
import '../main.css';

const HomeNavigation = ({
  children,
  classes,
  footer,
  isIndex,
  isHomePage,
}) => {


  const bottomNotIndex = (
    <div className={classes.leftBottomBackground}>
      <img className={classes.image} src={desktopFooter} alt={'background'} />
    </div>
  );

  const desktopLeftBubble = (
    <div className={classes.leftTopBackground}>
      <img className={classes.image} src={desktopHeaderLeft} alt={'background'} />
    </div>
  );

  return (
    <div className={classes.mainContainer}>
      <Header data={headerLinks} isIndex={isIndex} isHomePage={isHomePage} />
      <div className={classes.mainContent}>{children}</div>
      {footer && <Footer data={footerLinks} />}
      {!isIndex && (<MediaQuery minWidth={800}>{desktopLeftBubble}</MediaQuery>)}
      {(!isIndex && !footer) && bottomNotIndex}
    </div>
  );
};

HomeNavigation.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.any,
  footer: PropTypes.bool,
  isIndex: PropTypes.bool,
  isHomePage: PropTypes.bool,
};

HomeNavigation.defaultProps = {
  children: null,
  classes: {},
  footer: true,
  isIndex: false,
  isHomePage: false,
};

export default withStyles(styles)(HomeNavigation);
